export const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/',
  DEFAULT_LANGUAGE: 'en-us',
  CACHE_NAME: 'GoResto-V1',
  DATABASE_NAME: 'go-resto-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurants',
};

export default CONFIG;
